import darkThemeBase from './darkThemeBase';
import lightThemeBase from './lightThemeBase';

const ALIGNMENT_CONSTANTS = {
    left: 'left',
    right: 'right',
};

const PRESET_COLORS = [
    {
        main: '#00A76F',
    },
    {
        main: '#1877F2',
    },
    {
        main: '#FDA92D',
    },
    {
        main: '#7635DC',
    },
];

const THEME_MODE = {
    light: 'light',
    dark: 'dark',
};

export { darkThemeBase, lightThemeBase, ALIGNMENT_CONSTANTS, PRESET_COLORS, THEME_MODE };

const getCurrentThemeBase = (themeMode) => {
    return themeMode === THEME_MODE.dark ? darkThemeBase : lightThemeBase;
};

export default getCurrentThemeBase;
